import {
  AutoScroller,
  Cursor,
  Feedback,
  PointerActivationConstraints,
  PointerSensor,
  KeyboardSensor,
  PreventSelection
} from "@dnd-kit/dom";
import { RestrictToHorizontalAxis, RestrictToVerticalAxis } from "@dnd-kit/abstract/modifiers";

export const DragDropManagerModifierSetup = (
  lockAxis=false,
  horizontalList=false
) => (defaults) => [
  ...defaults,
  ...(
    !lockAxis ? [] : [
      horizontalList
        ? RestrictToHorizontalAxis
        : RestrictToVerticalAxis
    ]
  )
]

export const DragDropManagerSensorSetup = (useKeyboardSensor=false) => [
  PointerSensor.configure({
    activationConstraints({ pointerType}) {
      switch (pointerType) {
        case 'mouse':
          return [
            new PointerActivationConstraints.Distance({value: 5}),
          ];
        case 'touch':
          return [
            new PointerActivationConstraints.Delay({value: 250, tolerance: 5}),
          ];
        default:
          return [
            new PointerActivationConstraints.Delay({value: 200, tolerance: 10}),
            new PointerActivationConstraints.Distance({value: 5}),
          ];
      }
    },
  }),
  ...(useKeyboardSensor ? [KeyboardSensor] : [])
];

export const DragDropManagerPluginSetup = [
  AutoScroller,
  Cursor,
  Feedback,
  PreventSelection,
]